import _ from 'lodash';
import { sameComponentHookCriteria } from '../../helpers';
export function bindRouter(router, flowApi) {
  const {
    wixCodeApi,
    setProps
  } = flowApi.controllerConfig;
  const {
    isSSR
  } = flowApi.environment;
  const states = router.stateRegistry.get().filter(state => !!state.name).map(state => JSON.parse(JSON.stringify({
    name: state.name,
    url: state.url,
    parent: state.parent,
    data: state.data,
    params: state.params
  })));
  router.transitionService.onBefore({
    to: sameComponentHookCriteria
  }, handleStateUpdate);
  router.transitionService.onError({
    to: sameComponentHookCriteria
  }, handleStateUpdate);
  if (!isSSR) {
    router.urlService.listen();
  }
  return setProps({
    $$router$$: serialize(),
    $$router_methods$$: {
      go(state, params, options) {
        router.stateService.go(state, params, options);
      },
      reload(state) {
        router.stateService.reload(state);
      }
    }
  });
  function handleStateUpdate(transition) {
    setProps({
      $$router$$: serialize(transition)
    });
  }
  function serialize(transition) {
    const params = (transition == null ? void 0 : transition.params('to')) || router.globals.params;
    const state = (transition == null ? void 0 : transition.to().name) || router.globals.current.name;
    return {
      current: {
        state,
        params
      },
      states: _.keyBy(states, 'name'),
      location: _.pick(wixCodeApi.location, ['baseUrl', 'path', 'protocol', 'query', 'url'])
    };
  }
}
//# sourceMappingURL=bind.js.map